import ResourceCard from "../shared/ResourceCard";
import Loader from "../shared/Loader";
import FloatUp from "../shared/FloatUp";
import { Link } from "react-router-dom";
import AppContext from "../../context/Context";
import { getResources } from "../../context/Actions";
import { useEffect, useContext } from "react";

export default function Resources() {
  const { isLoading, resources, dispatch } = useContext(AppContext);

  useEffect(() => {
    dispatch({ type: "SET_LOADING" });
    const getResourcesList = async () => {
      const fetchedResources = await getResources();
      dispatch({
        type: "GET_RESOURCES",
        payload: fetchedResources,
      });
    };
    getResourcesList();
  }, [dispatch]);

  if (isLoading) return <Loader />;
  return (
    <div className="section my-6">
      <FloatUp>
        <div className="columns is-multiline">
          {resources.map((resource) => {
            return (
              <div key={resource._id} className="column is-one-third">
                <Link to={`/resources/${resource._id}`}>
                  <ResourceCard
                    name={resource.name}
                    imageUrl={resource.imgUrl}
                  />
                </Link>
              </div>
            );
          })}
        </div>
      </FloatUp>
    </div>
  );
}
